import { MapfreModalComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { LogoutService } from './../../../_services/_iam/logout.service';
import { Component, OnInit } from '@angular/core';
import { ModalOptions } from '@mapfre-design-library/src/public_api';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { Capacitor } from '@capacitor/core';
import { PolicyDataService } from '../../../_services/data-services/policy-data.service';
import { UserDataService } from '@services/data-services/user-data.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent],
  selector: 'app-loggedin-account-header',
  templateUrl: './loggedin-account-header.component.html',
})
export class LoggedinAccountHeaderComponent implements OnInit {
  headerAccountModalOptions: ModalOptions;
  hideModalOnRoute = false;
  padding = false;
  headerLogo: any;
  isAcmic: boolean;
  showPolicyDetails: boolean;
  policiesNotFound: boolean;
  user: any;
  
  constructor(
    private logoutService: LogoutService,
    private acmicService: AcmicService,
    private policyDataService: PolicyDataService,
    private userDataService: UserDataService
  ) {
    
  }
  getUserData() {
    this.userDataService.$userData.subscribe((user) => {
      if (user) {
        this.user = user;
        this.headerAccountModalOptions.modalTranslateCopy = this.user?.userDetails?.firstName;
      }
    });
  }
  
  // additionalButtonClasses: 'header-flat no-margin account account-header-no-margin',
  setModalOptions() {
    this.headerAccountModalOptions = new ModalOptions({
      additionalClasses: 'account modal-small loggedin-account-header',
      additionalButtonClasses: 'header-flat no-margin account account-header-no-margin-padding',
      animatePosition: 'top',
      buttonCopy: 'ACCOUNT',
      modalId: 'accountModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      modalTranslateCopy: 'ACCOUNT',
      typeOfModal: 'header',
      screenReader: true,
      showIcons: true,
      modalName: 'header_Account',
    });
  }
  hideModalAction(): void {
    this.hideModalOnRoute = !this.hideModalOnRoute;
  }

  logout() {
    this.logoutService.logout();
    this.hideModalOnRoute = !this.hideModalOnRoute;
  }

  resetHideModal(): void {
    this.hideModalOnRoute = !this.hideModalOnRoute;
  }

  onOpenModal(){    
    const backdrop = document.querySelector('.modal-backdrop') as HTMLElement;
    if(backdrop){
      backdrop.classList.add('header-backdrop')
      backdrop.style.backgroundColor = this.isAcmic ? '#4A4A4AB2' : '#61686C66';
    }
  }

  onModalHide(){
    // setTimeout(() => {
    //   // this.isOpenProfileModal = false
    // }, 500);
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    if (
      Capacitor.isNativePlatform() &&
      navigator.vendor &&
      Capacitor.getPlatform() === 'ios'
    ) {
      this.padding = true;
    }
    this.setModalOptions();
    this.getUserData();
    this.policyDataService.$policyDetails.subscribe((pList: any) => {
      if (pList) {
        if (pList.length) {
          this.policiesNotFound = false;
        } else {
          this.policiesNotFound = true;
        }
      }
    });
  }
}
